<template>
  <div>
    <h2 class="title-1 col">Баннер статистик</h2>
    <div class="stat-tabs mt-4">
      <h2 v-if="dailyStat != null" class="title-3 col">{{ dailyStat.banner.name }}</h2>
      <br />
      <div class="d-flex">
        <div
          :class="[{ 'tab--selected' : selectedTab === 'daily'}, 'nav-link tab']"
          @click="selectedTab = 'daily'"
        >Баннерын тайлан өдрөөр</div>
        <div
          :class="[{ 'tab--selected' : selectedTab === 'monthly'}, 'nav-link tab']"
          @click="selectedTab = 'monthly'"
        >Баннерын тайлан сараар</div>
      </div>
      <br />
      <!-- banner statistic daily tab -->
      <div v-if="selectedTab === 'daily' && dailyStat != null">
        <Banner-stat-daily :dailyStat="dailyStat" :start="dailyStatStart" :end="dailyStatEnd" />
      </div>
      <!-- uri access tab -->
      <div v-else-if="selectedTab === 'monthly' && monthlyStat != null">
        <Banner-stat-monthly
          :monthlyStat="monthlyStat"
          :start="monthlyStatStart"
          :end="monthlyStatEnd"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BannerStatDaily from "@/components/statistic/BannerStatisticDaily";
import BannerStatMonthly from "@/components/statistic/BannerStatisticMonthly";
import StatService from "@/services/StatService";

export default {
  name: "BannerStatisticDetail",

  components: { BannerStatDaily, BannerStatMonthly },

  created() {
    this.getDailyStats(null, null);
    this.getMonthlyStats(null, null);
  },

  data() {
    return {
      selectedTab: "daily",

      dailyStat: null,
      dailyStatStart: null,
      dailyStatEnd: null,

      monthlyStat: null,
      monthlyStatStart: null,
      monthlyStatEnd: null
    };
  },

  methods: {
    getDailyStats(start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        if (this.dailyStatStart == start && this.dailyStatEnd == end) return;
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.getBannerStatDaily(data, this.$route.params.id).then(
        response => {
          if (response.status == 200 && response.data.success == true) {
            this.dailyStatStart = response.data.payload.startDate;
            this.dailyStatEnd = response.data.payload.endDate;
            this.dailyStat = response.data.payload;
            this.$store.dispatch("setLoading", false);
          }
        }
      );
    },

    getMonthlyStats(start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        if (this.monthlyStatStart == start && this.monthlyStatEnd == end)
          return;
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.getBannerStatMonthly(data, this.$route.params.id).then(
        response => {
          if (response.status == 200 && response.data.success == true) {
            this.monthlyStatStart = response.data.payload.startDate;
            this.monthlyStatEnd = response.data.payload.endDate;
            this.monthlyStat = response.data.payload;
            this.$store.dispatch("setLoading", false);
          }
        }
      );
    },

    onDownloadExcel(stat, start, end) {
      let data = JSON.parse("{}");
      if (start != null && end != null) {
        data.start = start;
        data.end = end;
      }
      this.$store.dispatch("setLoading", true);
      StatService.downloadStat({ responseType: "blob" }, stat, data).then(
        response => {
          this.$store.dispatch("setLoading", false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName =
            stat == "user_stat_excel"
              ? stat + "_" + new Date().toISOString().split("T")[0] + ".xls"
              : stat + "_" + start + "_" + end + ".xls";
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    }
  }
};
</script>